var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80441 13.7977C4.06808 13.7977 4.26269 13.6722 4.57659 13.3896L6.89314 11.2991L10.9989 11.3054C12.8885 11.3054 13.9495 10.213 13.9495 8.34849V3.47056C13.9495 1.60603 12.8885 0.513672 10.9989 0.513672H2.99456C1.11119 0.513672 0.0439453 1.60603 0.0439453 3.47056V8.34849C0.0439453 10.2193 1.14258 11.2991 2.95061 11.2991H3.20173V13.1197C3.20173 13.534 3.42146 13.7977 3.80441 13.7977Z",
    fill: "#0767FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.80c1fbe1c13acfc2fd59899bdbaf9b70.svg";
export { ForwardRef as ReactComponent };